import { useState, useCallback, useContext } from 'react';
import { opsApiCall } from '../helpers/rapsapOpsAuth';
import { StoreContext } from '../context';

// Cache for stats data (simple in-memory cache)
const statsCache = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const useDeliveryStats = () => {
  const { storeId } = useContext(StoreContext);
  const [deliveryData, setDeliveryData] = useState({
    orders: {
      total_paid: 0,
      total_packed: 0,
      total_out_for_delivery: 0,
      delivered: 0,
      reschedule: 0,
    },
  });
  const [loading, setLoading] = useState(false);

  const fetchStats = useCallback(async (forceRefresh = false) => {
    const cacheKey = `delivery-stats-${storeId}`;
    const cached = statsCache.get(cacheKey);
    
    // Return cached data if valid and not forcing refresh
    if (!forceRefresh && cached && (Date.now() - cached.timestamp < CACHE_DURATION)) {
      setDeliveryData(cached.data);
      return;
    }

    setLoading(true);
    try {
      const res = await opsApiCall("/dashboard/dashboardHomepage", {
        store_id: storeId || "1",
        year: new Date().getFullYear(),
      });

      if (res?.success && res.data) {
        const newData = res.data;
        setDeliveryData(newData);
        
        // Cache the result
        statsCache.set(cacheKey, {
          data: newData,
          timestamp: Date.now()
        });
      }
    } catch (error) {
      console.error("Error fetching delivery stats:", error);
    } finally {
      setLoading(false);
    }
  }, [storeId]);

  return { deliveryData, loading, fetchStats };
};